import en from "translations/en";
import es from "translations/es";

const resources = {
  en,
  es,
};

export default resources;
